module.exports = __webpack_public_path__ + "img/70bU100WjWY59xP0k31Q9Z9hC901666078619620.bbb3036c.png";